import { PersonalInfoRoutes } from './routes';

const personalInfoRoutes = PersonalInfoRoutes();

export { personalInfoRoutes };
